export default __webpack_public_path__ + "static/media/alternative.a2f6e16b.svg";